(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /**
   * Hides the header wishlist heart while the shopper has not given cookie consent.
   *
   * Wishlist Plus stays off until the consent banner (Consentmo) records consent in
   * Shopify's Customer Privacy API, so without it the heart opens nothing. The heart
   * renders visible, which keeps the header still for shoppers who need no banner,
   * and this script hides it once the API says tracking is not allowed. It shows again
   * when the shopper accepts.
   */
  (() => {
    const selectors = {
      wishlist: '[data-header-wishlist]',
    };

    function sync() {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy) return;

      const allowed = privacy.userCanBeTracked();
      document.querySelectorAll(selectors.wishlist).forEach((wishlist) => {
        wishlist.hidden = !allowed;
      });
    }

    function start() {
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (error) return;

        sync();
      });
    }

    document.addEventListener('visitorConsentCollected', sync);
    document.addEventListener('shopify:section:load', sync);

    start();
  })();

  } catch(e) { console.error(e); }
})();
})();
